import { render, staticRenderFns } from "./AamsGiftRegUsageApprovalDetail.vue?vue&type=template&id=57632a7d&scoped=true&"
import script from "./AamsGiftRegUsageApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegUsageApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsGiftRegUsageApprovalDetail.vue?vue&type=style&index=0&id=57632a7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57632a7d",
  null
  
)

export default component.exports